import 'pp-vx/dist/components/radio/radio.css';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import clsx from 'clsx';

var componentClass = 'ppvx_radio';

var renderHelperText = function (text) {
  return text && React.createElement("p", {
    className: "".concat(componentClass, "__helper-text")
  }, text);
};

var Radio =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Radio, _React$Component);

  function Radio() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Radio);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Radio)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "generatedId", "Radio_".concat(Math.random().toFixed(8).toString().replace('0.', '')));

    return _this;
  }

  _createClass(Radio, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$id = _this$props.id,
          id = _this$props$id === void 0 ? this.generatedId : _this$props$id,
          label = _this$props.label,
          helperText = _this$props.helperText,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, ["id", "label", "helperText", "className"]);

      var classes = clsx(componentClass, className);
      return React.createElement("div", {
        className: classes
      }, React.createElement("input", _extends({
        className: "".concat(componentClass, "__input"),
        type: "radio",
        id: id
      }, rest)), React.createElement("label", {
        className: "".concat(componentClass, "__label"),
        htmlFor: id
      }, label), renderHelperText(helperText));
    }
  }]);

  return Radio;
}(React.Component);

var vxRadioGroupClass = 'ppvx_radio-group';

var RadioGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RadioGroup, _React$Component);

  function RadioGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RadioGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RadioGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "generatedName", "RadioGroup_".concat(Math.random().toFixed(8).toString().replace('0.', '')));

    return _this;
  }

  _createClass(RadioGroup, [{
    key: "render",
    value: function render() {
      var _clsx;

      var _this$props = this.props,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? this.generatedName : _this$props$name,
          label = _this$props.label,
          helperText = _this$props.helperText,
          errorText = _this$props.errorText,
          error = _this$props.error,
          children = _this$props.children;
      var message = (errorText || helperText) && React.createElement("label", {
        className: clsx((_clsx = {}, _defineProperty(_clsx, "".concat(vxRadioGroupClass, "__helper-text"), !error), _defineProperty(_clsx, "".concat(vxRadioGroupClass, "__error-text"), error), _clsx))
      }, error ? errorText : helperText);
      return React.createElement("fieldset", {
        className: clsx(vxRadioGroupClass, {
          'ppvx_field--error': error
        })
      }, React.createElement("legend", {
        className: "".concat(vxRadioGroupClass, "__label")
      }, label), children && React.Children.map(children, function (radio, index) {
        return React.createElement(Radio, _extends({
          key: index,
          name: name
        }, radio.props));
      }), message);
    }
  }]);

  return RadioGroup;
}(React.Component);

export { Radio, RadioGroup };
